export const translations = {
  ru: {
    languageName: 'Рус',
    today: 'Сегодня',
    jobs: 'Вакансии',
    candidates: 'Кандидаты',
    pipeline: 'Pipeline',
    chat: 'Чаты',
    ai: 'AI',
    applications: 'Отклики',
    profile: 'Профиль',
    cv: 'CV',
    todayPlan: 'План на сегодня',
    heroCopy: 'Careeva собирает задачи, вакансии, интервью, чаты и риски в один action-first экран.',
    askPlaceholder: 'Спроси Careeva: что делать дальше?',
    focusNow: 'Фокус сейчас',
    openSchedule: 'Открыть расписание',
    careerPlan: 'Твой план поиска работы',
    whatNeedsAttention: 'Что требует внимания',
    badgesTitle: 'Что значат индикаторы',
    cvBadge: 'CV — сила профиля и резюме: чем выше %, тем лучше match и response rate.',
    marketBadge: 'Market — предполагаемое изменение рыночной ценности по роли/зарплате.',
    stealthBadge: 'Stealth — режим видимости: Careeva действует осторожно и не раскрывает профиль без approve.',
    startNow: 'Начать',
    refresh: 'Обновить',
    analyze: 'Анализ',
    optimize: 'Оптимизировать',
    runSearch: 'Искать',
    reviewQueue: 'Проверить',
    autoRules: 'Правила auto-apply',
    done: 'Готово',
    snooze: 'Отложить 3ч'
  },
  en: {
    languageName: 'Eng',
    today: 'Today',
    jobs: 'Jobs',
    candidates: 'Candidates',
    pipeline: 'Pipeline',
    chat: 'Chats',
    ai: 'AI',
    applications: 'Applications',
    profile: 'Profile',
    cv: 'CV',
    todayPlan: 'Today plan',
    heroCopy: 'Careeva collects tasks, jobs, interviews, chats and risks into one action-first screen.',
    askPlaceholder: 'Ask Careeva: what should I do next?',
    focusNow: 'Focus now',
    openSchedule: 'Open schedule',
    careerPlan: 'Your job search plan',
    whatNeedsAttention: 'What needs attention',
    badgesTitle: 'Indicator meanings',
    cvBadge: 'CV — profile and resume strength: higher % means better match and response rate.',
    marketBadge: 'Market — estimated market value movement for your role and salary target.',
    stealthBadge: 'Stealth — visibility mode: Careeva acts carefully and does not expose your profile without approval.',
    startNow: 'Start now',
    refresh: 'Refresh',
    analyze: 'Analyze',
    optimize: 'Optimize',
    runSearch: 'Run search',
    reviewQueue: 'Review',
    autoRules: 'Auto-apply rules',
    done: 'Done',
    snooze: 'Snooze 3h'
  }
};

export function t(language, key) {
  return translations[language]?.[key] || translations.ru[key] || key;
}
